import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { GalleryDto, TenantDto } from '@picflow/types';
import { MadeWithPicflowButtonComponent } from '../../../gallery-shared/components/made-with-picflow-button/made-with-picflow-button.component';
import { sortGalleries } from '../../../lib/sort-galleries';
import { AppConfigService } from '../../../providers/config.service';
import { StateService } from '../../../services/state.service';
import { TenantService } from '../../../services/tenant.service';
import { GalleryItemComponent } from '../../../shared-extra/components/gallery-item/gallery-item.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TenantLogoAndContactsComponent } from '../../../shared/components/tenant-logo-and-contacts/tenant-logo-and-contacts.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { TenantIconLoaderComponent } from '../../components/tenant-icon-loader/tenant-icon-loader.component';

@Component({
  selector: 'app-tenant-profile-page',
  templateUrl: './tenant-profile-page.component.html',
  styleUrls: ['./tenant-profile-page.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonDirective,
    TooltipDirective,
    SvgComponent,
    RouterLink,
    GalleryItemComponent,
    MadeWithPicflowButtonComponent,
    TenantIconLoaderComponent,
    TenantLogoAndContactsComponent,
  ],
})
export class TenantProfilePageComponent implements OnInit {
  public config = inject(AppConfigService);
  public state = inject(StateService);
  private route = inject(ActivatedRoute);
  private platformId = inject(PLATFORM_ID);
  private tenantService = inject(TenantService);
  private check = inject(ChangeDetectorRef);

  tenant: TenantDto = this.route.snapshot.data.tenant;
  galleries: GalleryDto[] = this.route.snapshot.data.galleries;
  platformBrowser = isPlatformBrowser(this.platformId);
  showEditBanner = false;

  async ngOnInit() {
    this.sortGalleries();
    this.showEditBanner = await this.shouldShowEditBanner();
    this.check.detectChanges();
  }

  sortGalleries() {
    const sorting = this.tenant['public_gallery_sorting'] || 'position';
    sortGalleries(this.galleries, sorting);
  }

  private async shouldShowEditBanner() {
    if (!this.platformBrowser) return false;
    const tenant = this.state.tenants?.find(t => t.id === this.tenant.id);
    if (!tenant) return false;
    await this.tenantService.setActiveTenant(tenant);
    const role = this.state.activeTenantRole;
    if (role === 'admin' || role === 'owner') return true;
    return false;
  }
}
